import "./App.css";
import { useRoutes } from "react-router-dom";
import { routes } from "./Routes";
import useAuthCheck from "./hooks/useAuthCheck";
import useAuth from "./hooks/useAuth";
import useAdminCheck from "./hooks/useAdminCheck";

function App() {
  const authChecked = useAuthCheck();
  const isLoggedIn = useAuth();
  const isAdmin = useAdminCheck()
  const elements = useRoutes(routes(isLoggedIn, isAdmin));

  if (!authChecked) {
    return <div>Checking Auth...</div>;
  }
  return elements;
}

export default App;
